<script setup lang="ts">
import { RouterView } from 'vue-router';
import { useAngularState } from '@/composables/useAngularState';
import { preloadModals } from '@/composables/useModal';
import { useVueRouteState } from '@/composables/useVueRouteState';
import TabContent from '@/components/TabContent.vue';
import ModalManager from '@/ModalManager.vue';
import ToastManager from '@/ToastManager.vue';

const { currentUser } = useAngularState();
const { isVueRoute } = useVueRouteState();
preloadModals();

</script>

<template>
    <!-- invisible binding so DevTools shows it --> <div style="display:none">{{ currentUser?.Id }}</div>
    <TabContent v-if="isVueRoute">
        <RouterView />
    </TabContent>
    <ToastManager/>
    <ModalManager/>
</template>

<style scoped>

</style>
